const getters = {
  getSops: (state) => state.sops,
  getSop: (state) => state.sop,
};

export default getters;
